import { IncomingMessage } from 'http';

import { QueryFunctionContext, QueryKey } from '@tanstack/react-query';

import { fetchGroups } from '../../../services/groups';
import { getGroupsKey } from '../query-keys';

const getGroups = (
  options: {
    locale: string;
    reference?: string;
    bp_reference?: string;
    min_price?: string;
    max_price?: string;
    car_identifier?: string;
  },
  req?: IncomingMessage
): [
  QueryKey,
  (options: QueryFunctionContext) => ReturnType<typeof fetchGroups>
] => [
  getGroupsKey(options),
  ({
    queryKey: [
      ,
      locale,
      reference,
      bp_reference,
      min_price,
      max_price,
      car_identifier,
    ],
  }: QueryFunctionContext<string[], any>): Promise<TCategories> =>
    fetchGroups(
      { locale, reference, bp_reference, min_price, max_price, car_identifier },
      req
    ),
];

export default getGroups;
